<template>
  <curriculum-page :resource-params="resourceParams" />
</template>

<script>
/* List resources by curriculum code
 *
 * @parent:
 * @requests: /public/v1/curriculum
 * @events:
 * @props:
 * @components: CurriculumPage
 * @methods:
 */

import CurriculumPage from '~/components/category/CurriculumPage.vue';

export default {
  name: 'AustralianCurriculumV9All',
  components: {
    CurriculumPage,
  },
  async asyncData({ app, store, route, error }) {
    const data = {};

    // For the resource list query
    data.resourceParams = {
      perPage: 32,
      category: app.$config.curriculumV9Slug,
    };

    try {
      // Load the curriculum title, description and list of sub-categories
      const curriculum = await store.dispatch('loadCurriculum', {
        ...data.resourceParams,
        link: route.path,
      });

      // For meta fields
      data.title = app.$config.curriculumV9 + ' - ' + curriculum.name;
      data.description = app.$truncateString(curriculum.description, 160, true);
    } catch (err) {
      // No page matching this route
      error({ statusCode: 404, message: err.message, path: route.path });
    }

    return data;
  },
  data() {
    return {
      title: 'Australian Curriculum Teaching Resources',
      description: 'Browse resources by curriculum code',
      resourceParams: {},
    };
  },
  head() {
    return {
      title: this.title,
      meta: [
        { hid: 'title', name: 'title', content: this.title },
        { hid: 'description', name: 'description', content: this.description },
        { hid: 'og-title', property: 'og:title', content: this.title },
      ],
      link: this.$canonicalLink(this.$route),
    };
  },
};
</script>
